import $api from "../http";
import { AxiosResponse } from "axios";

export default class DocumentsService {

    static getTypes(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/type/')
    };

    static getNosologies(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/nosology/')
    };

    static getPoints(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/point/')
    };

    static getChapters(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/chapter/')
    };

    static createChapters(data: string): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/docs/chapter/', {'chapter': data})
    };

    static getPublishers(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/publisher/')
    };

    static createPublishers(data: string): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/docs/publisher/', {'publisher': data})
    };

    static getStatuses(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/status/')
    };

    static createStatuses(data: string): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/docs/status/', {'status': data})
    };

    static getDocsByType(doc_type_id: number, doc_point_id: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/docs/?doc_type=${doc_type_id}&point=${doc_point_id}`)
    };

    static getMyDocs(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/my/')
    };

    static createDoc(data: object): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/docs/s/', data)
    };

    static getDocuments(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/s/')
    };

    static updateDocument(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/docs/s/update/${id}`, data)
    };

    static removeDocument(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/docs/delete/${id}`)
    };

    static getRecommendations(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/docs/recommendations/')
    };

    static getAllRecommendationsByType(type: string, nos: string): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/docs/all_recs/?type=${type}&nosology=${nos}`)
    };

    static createRecommendation(data: object): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/docs/recommendations/', data)
    };

    static getRecommendation(id: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/docs/recommendations/${id}`)
    };

    static updateRecommendation(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/docs/recommendations/update/${id}`, data)
    };

    static removeRecommendation(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/docs/recommendations/delete/${id}`)
    };

};